// Идея позаимствована из vue-responsive-components
// и переделана на тригер callback'ов

import ResizeObserver from "resize-observer-polyfill";

function inserted(el, binding) {
  const callback = binding.value || (() => null);
  const handleResize = entries => {
    callback(entries[0]);
  };

  const observer = new ResizeObserver(handleResize);
  observer.observe(el);

  el._Observer = {
    observer
  };
}

function unbind(el) {
  if (!el._Observer) return;

  const { observer } = el._Observer;
  observer.disconnect();
  delete el._Observer;
}

const Responsive = {
  inserted,
  unbind
};

export { Responsive };
export default Responsive;
